import styled from 'styled-components';

import useProjectTemplate from './hooks/useProjectTemplate';
import Modal, { ModalHeader, ModalContent } from 'components/Modal';
import { PROJECT_TEMPLATE } from 'constants/commonConstants';
import SideBar from './components/SideBar';
import TemplateCard from './components/TemplateCard';

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  height: 640px;
`;

const GridContainer = styled.div`
  flex: 1;
  padding: 0px 26px;
  overflow: auto;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 30px;
`;

interface ProjectTemplateModalProps {
  onTemplateClick: (templateId: string) => void;
}

const ProjectTemplateModal = ({ onTemplateClick }: ProjectTemplateModalProps) => {
  const { selectedCategory, categories, templates, onCategoryClick } = useProjectTemplate();

  return (
    <Modal maxWidth={1200}>
      <ModalHeader>프로젝트 템플릿을 선택하세요</ModalHeader>
      <ModalContent>
        <Container>
          <SideBar selectedCategory={selectedCategory} categories={categories} onCategoryClick={onCategoryClick} />
          <GridContainer>
            <Title>{selectedCategory === 'all' ? '전체' : PROJECT_TEMPLATE[selectedCategory].name}</Title>
            <Grid>
              {templates.map((template) => (
                <TemplateCard
                  key={`template/${template.id}`}
                  template={template}
                  Icon={PROJECT_TEMPLATE[template.category].icon}
                  onTemplateClick={onTemplateClick}
                />
              ))}
            </Grid>
          </GridContainer>
        </Container>
      </ModalContent>
    </Modal>
  );
};

export default ProjectTemplateModal;
